import { useState } from 'react';
import { OtpInput } from '../../../../shared/components/OtpInput';
import { Button } from '../../../../shared/components/Buttons';
import { Snackbar } from '../../../../shared/components/Snackbar';
import { ArrowLeft } from 'react-feather';
import { useOtpForm } from '../../hooks/useOtpForm';

interface OtpFormProps {
  email: string;
  onBack?: () => void;
  isTablet?: boolean;
}

const OtpForm = ({ email, onBack, isTablet = false }: OtpFormProps) => {
  const [showResendSnackbar, setShowResendSnackbar] = useState(false);

  const {
    otpInputValue,
    isSubmitting,
    isResending,
    resendTimer,
    handleSubmit,
    handleResendCode,
    handleOtpChange,
    handleBack,
    formatTime,
    maskedEmail,
  } = useOtpForm({
    email,
    onBack,
    onResendSuccess: () => setShowResendSnackbar(true),
  });

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex  flex-col gap-[24px] ${isTablet ? 'w-full' : 'w-[360px]'}`}
    >
      <div className=" flex flex-col gap-[40px]">
        <div className="flex flex-col gap-[8px]">
          <h1 className="font-[400]  text-[28px] text-neutral-10">
            Zweryfikuj swoją tożsamość
          </h1>
          <p className={`text-bodyMedium text-on-surface-variant`}>
            Wprowadź 6-cyfrowy kod weryfikacyjny wysłany na adres {maskedEmail}
          </p>
        </div>
        <div className="flex items-start justify-start flex-col gap-[18px]">
          <div className="flex flex-col gap-[24px] w-full">
            <OtpInput
              value={otpInputValue.value}
              onChange={handleOtpChange}
              error={otpInputValue.hasError}
              errorMessage={otpInputValue.errorMessage}
              disabled={isSubmitting}
              autoFocus={true}
              size={isTablet ? 'large' : 'default'}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-[8px]">
        <Button
          color="primary"
          label={isSubmitting ? 'Weryfikacja...' : 'Zweryfikuj'}
          disabled={isSubmitting}
          size="Medium"
          className={isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'}
          buttonType="Square"
          type="submit"
        />
        <Button
          showIcon={true}
          icon={<ArrowLeft />}
          label={'Powrót do logowania'}
          size="Medium"
          disabled={isSubmitting}
          className={`text-primary-color-40 bg-transparent hover:bg-primary-color-40/8 ${
            isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          buttonType="Square"
          type="button"
          onClick={handleBack}
        />
      </div>
      <div className="flex items-start justify-start gap-[8px]">
        <p className="text-bodyMedium text-on-surface-variant">
          Nie otrzymałeś kodu?
        </p>
        {resendTimer > 0 ? (
          <span className="text-neutral-50 text-labelLarge">
            Wyślij ponownie{' '}
            <span className="text-bodyMedium text-on-surface-variant">
              za {formatTime(resendTimer)}
            </span>
          </span>
        ) : (
          <button
            type="button"
            onClick={handleResendCode}
            disabled={isResending}
            className={`text-labelLarge font-medium ${
              isResending
                ? 'text-neutral-50 cursor-not-allowed'
                : 'text-primary-color-40 hover:cursor-pointer'
            } ${isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            {isResending ? 'Weryfikacja...' : 'Wyślij kod ponownie'}
          </button>
        )}
      </div>
      <Snackbar
        open={showResendSnackbar}
        message="Nowy kod został wysłany na Twój adres e-mail."
        variant="info"
        onClose={() => setShowResendSnackbar(false)}
        autoHideDuration={5000}
        position="top-center"
        showCloseButton={true}
      />
    </form>
  );
};

export default OtpForm;
